import React from 'react'
import { EditorContent } from '@tiptap/react'

import RichTextEditorMenuBar from "./RichTextEditorMenuBar";

import "../pages/Email/styles/TipTap.scss"


const RichTextEditor = ({ editor, content, viewHtml }) => {
    return (
        <>
            <RichTextEditorMenuBar editor={editor}/>
            <EditorContent
                editor={editor}
                className={'RichTextEditor'}
            />
        </>
    )
}

export default RichTextEditor
